import React, { useEffect, useState, useContext } from "react";
import { UserContext } from "../../contexts/user";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import firebase from "firebase/app";

import styled from "styled-components";

const StripeForm = styled.form`
  // width: 30vw;
  min-width: 500px;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1), 0px 2px 5px 0px rgba(50, 50, 93, 0.1),
    0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  // padding: 40px;
  margin: 20px auto;

  @media only screen and (max-width: 550px) {
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }

  #payment-message {
    color: rgb(105, 115, 134);
    font-size: 16px;
    line-height: 20px;
    padding-top: 12px;
    text-align: center;
  }

  #payment-element {
    margin-bottom: 24px;
  }

  .public-checkout-input{
    margin-bottom: 18px;
    padding-right: 28px;

    #public-email-field{
      width: 100%;
      padding: 14px;
      border-radius: 8px;
      font-size: 16px;
      border: 1px solid #333;
      background: #161616;
      color: #ffffff;
      // &:focus-visible {
      //   border: 1px solid red !important;
        
      // }
        &:focus {
        outline: none; /* Remove default outline */
        border: 1px solid #D1FF03; /* Change border color on focus */
      }
    }
  }

  .discount-wrapper{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 18px;
    border: 2px solid #D1FF03;
    padding: 5px;
    border-radius: 10px;
    button{ 
      width: auto; 
      font-size: 14px;
    }
    #dicount-input{
      width: 55%;
      padding: 12px;
      font-size: 14px;
      color: #ffffff;
      border: 1px solid #393939;
      border-radius: 5px;
      background: transparent;
      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(0, 0, 0, 0.02);
      &:focus {
        outline: none;
        border: 0.5px solid #D1FF03;
      }

    }
    @media (max-width: 768px) {
      gap: 10px;
      #dicount-input { width: 100%; }
      button { width: 100%; }
    }
  }

  &.isCardPayment {
    #payment-element {
      display: none;
    }
  }

    .saved-cards {
    margin-bottom: 16px;

    .card-option {
      display: block;
      margin-bottom: 8px;
      font-size: 16px;

    }
  }

  .card-option {
    display: block;
    margin-bottom: 8px;
    font-size: 16px;
  }

  .new-card {
    margin-top: 12px;
  }

  button {
    background: #D1FF03;
    font-family: Fira Mono, monotype;
    color: #161616;
    border-radius: 8px;
    border: 0;
    padding: 12px 16px;
    font-size: 18px;
    font-weight: 700;
    cursor: pointer;
    display: block;
    transition: all 0.2s ease;
    box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
    width: 100%;
  }

  button:hover {
    background: #FECF38;
  }

  button:disabled {
    opacity: 0.5;
    cursor: default;
  }

  .spinner,
  .spinner:before,
  .spinner:after {
    border-radius: 50%;
  }

  .spinner {
    color: #ffffff;
    font-size: 22px;
    text-indent: -99999px;
    margin: 0px auto;
    position: relative;
    width: 20px;
    height: 20px;
    box-shadow: inset 0 0 0 2px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }

  .spinner:before,
  .spinner:after {
    position: absolute;
    content: "";
  }

  .spinner:before {
    width: 10.4px;
    height: 20.4px;
    background: #5469d4;
    border-radius: 20.4px 0 0 20.4px;
    top: -0.2px;
    left: -0.2px;
    -webkit-transform-origin: 10.4px 10.2px;
    transform-origin: 10.4px 10.2px;
    -webkit-animation: loading 2s infinite ease 1.5s;
    animation: loading 2s infinite ease 1.5s;
  }

  .spinner:after {
    width: 10.4px;
    height: 10.2px;
    background: #5469d4;
    border-radius: 0 10.2px 10.2px 0;
    top: -0.1px;
    left: 10.2px;
    -webkit-transform-origin: 0px 10.2px;
    transform-origin: 0px 10.2px;
    -webkit-animation: loading 2s infinite ease;
    animation: loading 2s infinite ease;
  }

  @keyframes loading {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @media only screen and (max-width: 600px) {
    width: 80vw;
    min-width: initial;
  }
`;

export default function CheckoutForm({ customerCards = [], applyCoupon, params, paymentIntentId }) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState("new");
  const { authenticated: authed = false, setUserData } = useContext(UserContext);
  const [codeApplied, setCodeApplied] = useState(false);
  const [codeError, setCodeError] = useState();

  useEffect(() => {
    if (customerCards?.length > 0) {
      setSelectedMethod(customerCards[0]?.id);
    }
  }, [customerCards]);

  const attachCostumerAndCreateAccount = async data => {
    const mongoUrl = new URL(
      "https://us-central1-hackernoon-app.cloudfunctions.net/hackernoonMongo2/services/attach-email-to-intent",
    );
    // const mongoUrl = new URL("http://localhost:8087/services/attach-email-to-intent");
    try {
      const req = await fetch(mongoUrl?.toString(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: bearer,
        },
        body: JSON.stringify(data),
        // mode: "cors",
        // credentials: "include",
      });
      const response = await req.json();
      // console.log("response", response);
      if (response?.ok) {
        return response;
      }
    } catch (e) {
      console.log("something went wrong!", e);
    }
  };

  const checkDiscountCode = async (e) => {
    e.preventDefault();
    var formEl = document.getElementById("payment-form");
    if (formEl) {
      var formData = new FormData(formEl);
      var discount_code = formData.get("discount_code");
    }

    if (!formEl || !discount_code || discount_code?.length === 0) {
      return;
    }

    // console.log(discount_code, params);
    const val = await applyCoupon(discount_code, params, paymentIntentId);
    if (val) {
      setCodeApplied(true);
      if (codeError) setCodeError();
    } else {
      setCodeError("Incorrect code, please try again!");
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (!stripe || !elements || !params) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    //handles purchases that are public
    if (!authed) {
      var formEl = document.getElementById("payment-form");
      if (formEl) {
        var formData = new FormData(formEl);
        var email = formData.get("email");
        const intent = elements?._commonOptions?.clientSecret?.id;
        if (email && intent) {
          // console.log("email", email, params, intent);
          const newUser = await attachCostumerAndCreateAccount({ email, intent });
          if (!newUser) {
            setMessage("Something went wrong, please reload the page and try again!");
            return;
          } else {
            const { email, uid, firebaseToken = null } = newUser;
            params.offline = "true";
            params.email = email;
            params.uid = uid;
            if(firebaseToken){
              const {user} = await firebase.auth().signInWithCustomToken(firebaseToken);
              if(user){
                await setUserData(user);
                // console.log("user signed in!", user);
              }
            }
          }
        }
      }
    }

    

    // const redirectUrl = new URL("https://greenteam.hackernoon.com:3000/redirect-payment");
    const redirectUrl = new URL("https://courses.hackernoon.com/redirect-payment");
    redirectUrl.search = new URLSearchParams(params);
    // console.log(selectedMethod, paymentIntentId);

    const paymentData = {
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: redirectUrl.toString(),
      },
    };

    if (selectedMethod !== "new") {
      const { currentUser } = firebase.auth();

      if (!currentUser) {
        return setMessage("You must be logged in!");
      }

      if (!paymentIntentId) {
        return setMessage("An unexpected error occurred.");
      }

      try {
        const token = await currentUser.getIdToken();

        const url = new URL(
          "https://us-central1-hackernoon-app.cloudfunctions.net/hackernoonMongo2/services/update-payment-intent-with-payment-method",
        );
        // const url = new URL("http://localhost:8087/services/update-payment-intent-with-payment-method");
        const res = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
          body: JSON.stringify({
            paymentIntentId: paymentIntentId, // pass down from props/context
            paymentMethodId: selectedMethod,
          }),
        });

        const response = await res.json();
        if (response?.ok === true) {
          delete paymentData.elements;
          paymentData.clientSecret = response?.clientSecret;
          paymentData.confirmParams.payment_method = selectedMethod;
          // console.log("data set!")
        } else {
          return setMessage("An unexpected error occurred.");
        }
      } catch (e) {
        console.log("something went wrong", e);
        return setMessage("An unexpected error occurred.");
      }
    }

    const { error } = await stripe.confirmPayment(paymentData);

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs",
    appearance: {
      variables: {
        colorPrimary: '#D1FF03', // Green for primary elements
        colorBackground: '#4b4b4b',
        colorText: '#ffffff',
        colorDanger: '#df1b41',
        spacingUnit: '4px',
        borderRadius: '8px',
        focusBoxShadow: 'none', 
      },
      rules: {
        '.Input': {
          backgroundColor: '#4b4b4b',
          border: '1px solid #D1FF03', // Green border
          color: '#ffffff',
          padding: '14px',
          boxShadow: '0 0 0 0 transparent',
        },
        '.Input:focus': {
          border: '1px solid #D1FF03', // Thicker green border on focus
          outline: 'none',
          boxShadow: '0 0 0 0 transparent',
        },
        '.Label': {
          color: '#D1FF03', // Green labels
          fontWeight: '500',
          marginBottom: '8px',
        },
        '.Tab': {
          backgroundColor: '#18191a',
          border: '1px solid #D1FF03', // Green border for tabs
          color: '#ffffff',
          boxShadow: '0 0 0 0 transparent',
        },
        '.Tab:focus': {
          boxShadow: '0 0 0 0 transparent',
          outline: 'none',
        },
        '.Tab:hover': {
          backgroundColor: '#D1FF03', // Green background on hover
          color: '#161616',
          boxShadow: '0 0 0 0 transparent',
        },
        '.Tab--selected': {
          backgroundColor: '#D1FF03', // Green when selected
          color: '#161616',
          border: '1px solid #D1FF03',
          boxShadow: '0 0 0 0 transparent',
        },
        '.Tab--selected:focus': {
          boxShadow: '0 0 0 0 transparent',
        },
        '.DropdownItem': {
          backgroundColor: '#18191a',
          color: '#ffffff',
        },
        '.DropdownItem:hover': {
          backgroundColor: '#D1FF03', // Green on hover
          color: '#161616',
        },
        '.DropdownItem--selected': {
          backgroundColor: '#D1FF03', // Green when selected
          color: '#161616',
        }
      }
    }
  };

  if (!stripe) return null;

  return (
    <StripeForm id="payment-form" onSubmit={handleSubmit} className={selectedMethod !== "new" ? "isCardPayment" : ""}>
      <div className="discount-wrapper">
        <input
          id="dicount-input"
          type="input" name="discount_code"
          placeholder="Discount Code"
          // style={{ width: codeApplied ? "50%" : "60%" }}
        />
        <button type="button" disabled={codeApplied} onClick={checkDiscountCode}>{codeApplied ? "Discount Applied ✅" : "Apply Discount"}</button>
      </div>
      {codeError && <p style={{ color: "red", marginBottom: "18px" }}>{codeError}</p>}

      {!authed && (
        <div className="public-checkout-input">
          <input id="public-email-field" type="email" name="email" placeholder="email@domain.com" required />
        </div>
      )}

      {customerCards?.length > 0 && (
        <>
          <h3 className="">Choose Payment Method</h3>
          {/* Saved Cards */}
          <div className="saved-cards">
            {customerCards?.map(pm => (
              <label key={pm?.id} className="card-option">
                <input
                  style={{ cursor: "pointer", width: "auto" }}
                  type="radio"
                  name="payment"
                  value={pm?.id}
                  checked={selectedMethod === pm?.id}
                  onChange={e => setSelectedMethod(e.target.value)}
                />
                <strong>{pm?.card.brand.toUpperCase()}</strong> •••• <strong>{pm?.card.last4} </strong> (exp{" "}
                {pm?.card.exp_month}/{pm?.card.exp_year})
              </label>
            ))}
          </div>

          <label className="card-option new-card">
            <input
              style={{ cursor: "pointer", width: "auto" }}
              type="radio"
              name="payment"
              value="new"
              checked={selectedMethod === "new"}
              onChange={e => setSelectedMethod("new")}
            />
            Add new card:
            {/* {selectedMethod === "new" && (
              <div className="card-element-container">
                <CardElement />
              </div>
            )} */}
          </label>
          <br />
        </>
      )}

      <PaymentElement id="payment-element" options={paymentElementOptions} />

      <button disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">{isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}</span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </StripeForm>
  );
}